// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"295":"c4a97e56","832":"b52f439e"}[chunkId] + ".js";
};